/**
 * @file CartPlatformGroup.tsx
 * @description Группа «Задаёт платформа» «Вида корзины» — только просмотр,
 * свёрнута по умолчанию (phase19.16, SB120 этап 4; uiux-cart §4,
 * db-design-sb120-stage4 §6): состав корзины, касание, закрытие и переход к
 * оформлению заказа одинаковы у всех магазинов — без них покупатель не
 * оформит заказ или не справится с корзиной на телефоне.
 */

import { FieldHint, SettingsGroup } from "../../ui/settings-groups";
import { LockedRow } from "../header-footer/LockedRow";

/** Что ставит платформа (реестр строк). */
const PLATFORM_ROWS: readonly string[] = [
  "Заголовок «Ваша корзина» и состав строк: фото, название, вариант, цена",
  "Кнопки −/+ с полем касания 48 px и «удалить» у строки",
  "«Удалить все» и «Итого» внизу корзины",
  "Закрытие по Esc и кнопкой «Закрыть»; фокус остаётся в панели",
  "«Оформить заказ» ведёт на оформление заказа",
];

export function CartPlatformGroup() {
  return (
    <SettingsGroup id="platform" title="Задаёт платформа" tocLabel="Платформа" status="readonly" summary="только просмотр">
      {PLATFORM_ROWS.map((row) => (
        <LockedRow key={row}>{row}</LockedRow>
      ))}
      <FieldHint className="mt-0">Состав корзины задаёт платформа — здесь меняется только вид.</FieldHint>
    </SettingsGroup>
  );
}
